import { defineMessages } from 'react-intl';

export default defineMessages({
  caption: { defaultMessage: 'Connect your wallet' },
});
